import { render } from "./PersonalScoreboard.vue?vue&type=template&id=2250002b&scoped=true"
import script from "./PersonalScoreboard.vue?vue&type=script&lang=js"
export * from "./PersonalScoreboard.vue?vue&type=script&lang=js"

import "./PersonalScoreboard.vue?vue&type=style&index=0&id=2250002b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2250002b"]])

export default __exports__